export function getEnv(baseUrl: string) {
  const environment = {
    authURL: `${baseUrl}/auth`,
    captchaURL: `${baseUrl}/captcha`,
    picturesURL: `${baseUrl}/hotel-wl/v1/picture/convert`,
    picturesNameURL: `${baseUrl}/hotel-wl/v1/picture`,
    unsecuredURL: `${baseUrl}/hotel-wl/v1/unAuthorized`,
    baseURL: `${baseUrl}/hotel-wl/v1`,
    tour_services_url: `${baseUrl}/tour`,
    isCitaTrip: false,
    hiddenTour: false,

    // production: true,
    // whiteLabel | cita | hotel-wl
    typeSite: 'hotelWL',
    url: 'cita'
  };
  return environment;
}
